import { type UserIdentity } from "react-admin";

import { createApiClient } from "@/api";
import { queryClient } from "@/constants";
import { accessList } from "@/providers/authProvider/accessList.ts";

export const apiClient = createApiClient("json");

export const getIdentityFromCache = async () =>
  queryClient.ensureQueryData<UserIdentity>({
    queryKey: ["auth", "getIdentity"],
  });

const ACTION_TYPES: Record<string, string> = {
  list: "get",
  show: "get",
  edit: "put",
  create: "post",
  delete: "delete",
};

export const getAccessName = (resource: string, action: string) => {
  return [
    "ROLE",
    accessList[resource],
    ["list", "create"].includes(action) ? "collection" : "item",
    ACTION_TYPES[action],
  ].join("_");
};
